import { Grid, TextField, RadioGroup, FormControlLabel, Radio, Divider } from '@mui/material'
import Paragraph from '../../../../../../shared/UI/Paragraph'
import { RtwMaintenanceRequest } from '../../../../../../types/return-to-work'
import { boolToString, stringToBool } from '../../../../../../utils/rtwUtils'

type Props = {
  companyAction: boolean
  companyActionComments: string
  onFieldChange: (field: keyof RtwMaintenanceRequest, value: any) => void
}

function CompanyActionSection({ companyAction, companyActionComments, onFieldChange }: Props) {
  return (
    <>
      <Grid item xs={12}>
        <Paragraph>Is there anything bet365 can do to prevent (further) recurrence?</Paragraph>
        <RadioGroup
          row
          aria-labelledby="company-action-radio-group"
          name="company-action-radio-group"
          value={boolToString(companyAction)}
          onChange={(e, checked) => {
            onFieldChange('companyAction', stringToBool(checked))
          }}
        >
          <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
          <FormControlLabel value="No" control={<Radio />} label="No" />
        </RadioGroup>
      </Grid>
      <Grid item xs={12} mt={2}>
        <TextField
          id="anything-bet365-additional-comment"
          label="Additional comment"
          variant="outlined"
          value={companyActionComments}
          onChange={(e) => onFieldChange('companyActionComments', e.target.value)}
          fullWidth
          sx={{ paddingBottom: '8px' }}
        />
        <Divider sx={{ margin: '30px 0' }} />
      </Grid>
    </>
  )
}

export default CompanyActionSection